import { unitStatusColors, UnitStatusKey } from '../common/helpers/styles';
import { colors } from '../colors/colors';
import { ConfigLookup, PaletteTokens, toCssVar } from './color-sound-config-resolver';
import { useUnitStateColor } from './use-configured-colors';

export interface UnitStatusColors {
    fill: string;
    text: string;
}

/**
 * The configured color for a unit status, falling back to today's color for its unit state group.
 * An explicit "no color" renders an unfilled pill with the held-unit text color.
 */
export function getConfiguredUnitStatusColors(
    configuredColor: ConfigLookup<PaletteTokens>,
    unitStateGroup: UnitStatusKey | null | undefined
): UnitStatusColors {
    if (configuredColor.matched) {
        return configuredColor.value
            ? {
                  fill: toCssVar(configuredColor.value.baseToken, configuredColor.value.hex),
                  text: toCssVar(configuredColor.value.contentToken),
              }
            : { fill: '', text: colors.unitStatusHeldText };
    }
    return { ...unitStatusColors[unitStateGroup ?? 'NO_UNIT_STATE_GROUP'] };
}

// Reads a MobX observable, so callers must be `observer` components.
export function useUnitStatusColors(
    unitStateId: number | null | undefined,
    unitStateGroup: UnitStatusKey | null | undefined
): UnitStatusColors {
    return getConfiguredUnitStatusColors(useUnitStateColor(unitStateId), unitStateGroup);
}
